import React, { FC, useCallback, useEffect, useState } from 'react';
import { CardButton } from '../card-button/CardButton';
import { Box, Card, CardContent, CardMedia, Chip, IconButton, Typography } from '@mui/material';
import styles from './card.module.scss';
import { wordsResponse } from '../../types';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
const player = new Audio();
import { AudioButton } from '../audio-button/AudioButton';
interface wordsProps {
  words: wordsResponse;
  idx: number;
}

export const CardItem: FC<wordsProps> = ({ words, idx }) => {
  const {
    id,
    image,
    word,
    transcription,
    textExample,
    textMeaning,
    textExampleTranslate,
    textMeaningTranslate,
    wordTranslate,
    userWord,
    _id,
    page,
    group,
    audio,
    audioExample,
    audioMeaning,
  } = words;
  const { isAuthorized } = useTypedSelector((state) => state.auth);
  const [disabled, setDisabled] = useState(false);
  const audioStatsRight = userWord?.optional.audio.right || 0;
  const audioStatsWrong = userWord?.optional.audio.wrong || 0;
  const sprintStatsWrong = userWord?.optional.sprint.wrong || 0;
  const sprintStatsRight = userWord?.optional.sprint.right || 0;
  const audioLink = `${process.env.REACT_APP_API_URL}${audio}`;
  const audioExampleLink = `${process.env.REACT_APP_API_URL}${audioExample}`;
  const audioMeaningLink = `${process.env.REACT_APP_API_URL}${audioMeaning}`;
  const imageURL = `${process.env.REACT_APP_API_URL}${words?.image}`;
  const audioLinks = [audioLink, audioMeaningLink, audioExampleLink];
  return (
    <div className={styles.item}>
      <Card sx={{ maxWidth: 345, minHeight: 600 }}>
        <CardMedia
          component="img"
          alt={words?.word}
          height="140"
          sx={{ maxHeight: 230, minHeight: 230 }}
          image={imageURL}
        />
        <div className={styles.content}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {words?.word} - {words.wordTranslate}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h5" color="text.secondary">
                {words?.transcription}
              </Typography>
              <AudioButton audioLinks={audioLinks} player={player} />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: 200,
                fontSize: 16,
              }}
            >
              <Box>
                <Typography variant="body1">Значение</Typography>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: textMeaning }}
                ></Typography>
                <Typography variant="body2">{textMeaningTranslate}</Typography>
              </Box>
              <Box>
                <Typography variant="body1">Пример</Typography>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: textExample }}
                ></Typography>
                <Typography variant="body2">{textMeaningTranslate}</Typography>
              </Box>
            </Box>
            <div className={styles.wrapper}>
              {isAuthorized && (
                <div className={styles.stats_game}>
                  <Typography variant="h6" color="text.secondary">
                    Статистика по играм
                  </Typography>
                  <div className={styles.stats_item}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Спринт
                    </Typography>
                    <div className={styles.chip_wrapper}>
                      <Chip icon={<ClearIcon />} label={sprintStatsWrong} />
                      <Chip icon={<CheckIcon />} label={sprintStatsRight} color="info" />
                    </div>
                  </div>

                  <div className={styles.stats_item}>
                    <Typography variant="subtitle1" color="text.secondary">
                      Аудиовызов
                    </Typography>
                    <div className={styles.chip_wrapper}>
                      <Chip icon={<ClearIcon />} label={audioStatsWrong} />
                      <Chip icon={<CheckIcon />} label={audioStatsRight} color="info" />
                    </div>
                  </div>
                </div>
              )}
              <div className={styles.wrapper_btn}>
                {isAuthorized && (
                  <CardButton
                    word={userWord}
                    id={id}
                    _id={_id}
                    page={page}
                    group={group}
                    idx={idx}
                  />
                )}
              </div>
            </div>
          </CardContent>
        </div>
      </Card>
    </div>
  );
};
